<template>
  <div
    v-show="nearbyTransport && nearbyTransport.length"
    class="nearby-transport-group"
  >
    <div class="title">
      <img
        loading="lazy"
        :src="transportIconUrl"
        class="transport-icon"
        width="22"
        height="22"
        alt=""
      />{{ title }}
    </div>
    <div
      v-for="(nearbyPoint, index) in nearbyTransport"
      :key="index"
      class="nearby-row"
    >
      <translate
        class="distance"
        :tt="{
          value: convertToDistanceObject(nearbyPoint.distance.toString()),
        }"
      >
        {value, distance, short}
      </translate>
      <span>{{ nearbyPoint.name }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { computed } from 'vue'
import { Distance } from '~/utility/geo/Distance'
import { NearbyTransportEntry } from '~/apps/campsite-details/types'

const props = defineProps<{
  stationType: string
  nearbyTransport?: NearbyTransportEntry[]
  title: string
}>()

const transportIconUrl = computed(() => {
  // https://www.lichter.io/articles/nuxt3-vue3-dynamic-images/#the-importmetaglob-trick
  const glob = import.meta.glob('@/assets/transport-icons/*.svg', {
    query: '?url',
    eager: true,
  })
  return glob[`/assets/transport-icons/${props.stationType}.svg`].default
})

function convertToDistanceObject(distanceInMeters: string) {
  const km = parseInt(distanceInMeters.replace(' m', ''), 10) / 1000
  return Distance.new({ km })
}
</script>

<style scoped>
.transport-icon {
  width: 1.5em;
  height: auto;
  margin: 0 0.5em 0 0;
}
.nearby-transport-group {
  margin: 0 0 1em 0;
  flex: 1 0 auto;
}
.title {
  margin: 0 0 0.3em 0;
  font-weight: bold;
}
.nearby-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-top: 1px solid #eee;
  padding: 0.2em 0;
}
.nearby-row .distance {
  flex: 0 0 4em;
}
</style>
